var COUPON = {
  /** 어드민 발행 */
  ADMIN_PUBLISH: 'ADMIN_PUBLISH',
  /** 코드형 */
  CODE: 'CODE',
  /** 다운로드형 */
  DOWNLOAD: 'DOWNLOAD',
  /** CRM 다운로드형 */
  CRM_DOWNLOAD: 'CRM_DOWNLOAD',
  /** 자동발급형 */
  AUTO_PUBLISH: 'AUTO_PUBLISH',
  /** 난수쿠폰형 */
  RANDOM_CODE: 'RANDOM_CODE',
  /** 첫구매형 */
  FIRST_ORDER: 'FIRST_ORDER',
  /** 비공개형 */
  HIDDEN: 'HIDDEN'
};
var COUPON_TYPE_OPTIONS = [{
  value: COUPON.ADMIN_PUBLISH,
  label: '어드민 발행'
}, {
  value: COUPON.CODE,
  label: '코드형'
}, {
  value: COUPON.DOWNLOAD,
  label: '다운로드형'
}, {
  value: COUPON.FIRST_ORDER,
  label: '첫구매형'
}, {
  value: COUPON.AUTO_PUBLISH,
  label: '자동발급형'
}, {
  value: COUPON.RANDOM_CODE,
  label: '난수쿠폰형'
}, {
  value: COUPON.HIDDEN,
  label: '다운로드 비공개형'
}];
var CUSTOMER_TYPE = {
  ALL: 'ALL'
};
var COUPON_TYPE = {
  PRODUCT: 'PRODUCT'
};
var DISCOUNT_TYPE = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  FIXED_RATE: 'FIXED_RATE'
};
var PUBLISH_TYPE = {
  DOWNLOAD: 'DOWNLOAD',
  CRM_DOWNLOAD: 'CRM_DOWNLOAD'
};
var EXPIRATION_TYPE = {
  FIXED_DATE: 'FIXED_DATE',
  DAYS_AFTER_PUBLISH: 'DAYS_AFTER_PUBLISH'
};
var PUBLISH_STATE = {
  BEFORE_PUBLISH: 'BEFORE_PUBLISH',
  PUBLISHABLE: 'PUBLISHABLE',
  PUBLISH_EXPIRED: 'PUBLISH_EXPIRED',
  TERMINATED_BY_ADMIN: 'TERMINATED_BY_ADMIN',
  TERMINATED_BY_BUDGET: 'TERMINATED_BY_BUDGET',
  TERMINATED_BY_COUNT: 'TERMINATED_BY_COUNT'
};
var SETTLEMENT_METHOD_TYPE = {
  SETTLEMENT_DEDUCTION: 'SETTLEMENT_DEDUCTION',
  CREDIT: 'CREDIT'
};

export { COUPON, COUPON_TYPE, COUPON_TYPE_OPTIONS, CUSTOMER_TYPE, DISCOUNT_TYPE, EXPIRATION_TYPE, PUBLISH_STATE, PUBLISH_TYPE, SETTLEMENT_METHOD_TYPE };
//# sourceMappingURL=type.js.map
